import { render } from "./mathStockyard.vue?vue&type=template&id=25c56960&scoped=true"
import script from "./mathStockyard.vue?vue&type=script&lang=js"
export * from "./mathStockyard.vue?vue&type=script&lang=js"

import "./mathStockyard.vue?vue&type=style&index=0&id=25c56960&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c56960"]])

export default __exports__